"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTimestamp = exports.getMoment = exports.getDateDiffFromNow = exports.fromTimestamp = exports.formattedDate = void 0;
var _moment = require("./vendor/moment");
var _state = require("../state");
const getMoment = () => {
  const {
    locale
  } = _state.store.getState().config.values || {};
  return (0, _moment.getLocalizedMoment)(locale);
};
exports.getMoment = getMoment;
const toTimestamp = date => {
  const moment = getMoment();
  return date ? moment(date).unix() : null;
};
exports.toTimestamp = toTimestamp;
const fromTimestamp = timestamp => {
  const moment = getMoment();
  return timestamp ? moment.unix(timestamp) : timestamp;
};
exports.fromTimestamp = fromTimestamp;
const formattedDate = (date, defaultValue, passedFormat) => {
  const {
    dateFormat: fallbackFormat
  } = _state.store.getState().config.values || {};
  const format = passedFormat || fallbackFormat;
  const moment = getMoment();
  return date ? moment(date).format(format) : defaultValue;
};
exports.formattedDate = formattedDate;
const getDateDiffFromNow = date => {
  const moment = getMoment();
  return moment(date).diff(moment(), 'day');
};
exports.getDateDiffFromNow = getDateDiffFromNow;